<template>
    <div
        class="a-control a-control--search a-select"
        v-click-outside="hide"
    >
        <a-button
            icon="Close"
            class="a-control__remove"
            @click.prevent="close"
            v-show="searchText != ''"
        />
        <input
            class="a-control__input a-select__input"
            :class="{
                'a-control__input--remove':searchText != '',
                'a-control__input--gray': backgroundGray === true
            }"
            type="text"
            :placeholder="placeholder"
            :value="searchText"
            @input="searchText = $event.target.value"
            @click="onClick($event)"
            @keyup.enter="$emit('enter')"
            :name="name"
            :id="id"
        />
        <div
            class="a-select__list"
            :class="{'a-select__list--fullwidth': fullwidth}">
            <div
                v-if="quickSearch && quickSearch.length > 0"
                class="a-select__listContainer"
            >
                <p
                    class="a-select__listItem"
                    v-for="(item, idx) in quickSearch"
                    v-bind:key="`${item}${idx}`"
                    @click="listClick($event, item)"
                >
                    <span
                        v-if="(!filterWholeList || item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) && !hideSingle || Array.isArray(item.id)"
                    >
                        {{ item.name ? item.name : item }}
                    </span>
                </p>
            </div>
            <p
                v-else
                class="a-select__listItem a-select__listItem--unhoverable"
                @click="hide"
            >
                <span
                    v-if="quickSearchStatus === 'loading' || quickSearchStatus === 'error'"
                    class="a-select__listLoader"
                >
                    <a-icon icon="SpinnerSmall" />
                    Ładowanie...
                </span>
                <span v-else>Brak wyników</span>
            </p>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
export default {
    directives: {
        ClickOutside
    },
    data() {
        return {
            inputText: '',
            selectedItems: [],
            searchAfter: this.searchAtOnce ? 0 : 3
        }
    },
    watch: {
        value() {
            if(typeof this.value === 'string' && this.value === '') {
                this.close()
            }
        }
    },
    props: {
        placeholder: {
            type: String
        },
        value: {
            type: [String, Object, Array],
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ''
        },
        modelName: {
            type: String,
            default: ''
        },
        backgroundGray: {
            type: Boolean,
            default: false
        },
        params: {
            type: Object,
            default: () => {}
        },
        object: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        searchAtOnce: {
            type: Boolean,
            default: false
        },
        fullwidth: {
            type: Boolean,
            default: false
        },
        filterWholeList: {
            type: Boolean,
            default: false
        },
        hideSingle: {
            type: Boolean,
            default: false
        },
        vuexFetchQuickSearch: {
            tyle: String,
            default: 'fetchQuickSearch'
        },
        disableOnClick: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        quickSearchStatus() {
            return this.$store.getters.quickSearchStatus
        },
        quickSearch() {
            return this.$store.getters.quickSearch
        },
        searchText: {
            get() {
                return this.inputText
            },
            set(searchText) {
                this.inputText = searchText
                if(!this.object) {
                    // emit component event
                    this.$emit('input', searchText)
                }
                // limit to 3 chars
                if(searchText.length >= this.searchAfter) {
                    this.$el.children[2].style.display = 'block'
                    if(searchText.length >= this.searchAfter && searchText.length >= 1) {
                        this.$store.dispatch(this.vuexFetchQuickSearch, {
                            name: this.modelName ? this.modelName : this.name,
                            query: searchText,
                            params: this.params,
                            object: this.object
                        }).catch(() => {})
                    }
                } else {
                    this.hide()
                }
            }
        }
    },
    methods: {
        hide() {
            this.$el.children[2].style.display = 'none'
        },
        onClick($event) {
            this.$scrollTo($event.target, 500, {
                // top nav height + margin
                offset: -65
            })
            if(this.searchText.length >= this.searchAfter) {
                // toggle list
                if(window.getComputedStyle($event.target.nextSibling).display !== 'block') {
                    $event.target.nextSibling.style.display = 'block'
                    this.$store.dispatch(this.vuexFetchQuickSearch, {
                        name: this.modelName ? this.modelName : this.name,
                        query: this.searchText,
                        params: this.params,
                        object: this.object
                    }).catch(() => {})
                } else {
                    this.hide()
                }
            } else {
                this.hide()
            }
        },
        listClick($event, item) {
            if(this.multiple) {
                this.selectedItems = this.value
                const selectedIdx = this.value.findIndex(selected => selected.id === item.id)
                if(selectedIdx === -1 && typeof item.id !== 'object') {
                    // add new
                    this.selectedItems.push(item)
                }
                this.searchText = ''
            } else if(!this.disableOnClick) {
                this.searchText = item.name ? item.name : item
            }
            if(this.object) {
                if(this.multiple) {
                    if(typeof item.id === 'object') {
                        // item.id is the array with IDs
                        item.id.forEach(arrayItem => {
                            const foundItem = this.quickSearch.find(wholeListIitem => typeof wholeListIitem.id === 'number' && wholeListIitem.id === arrayItem)
                            if(foundItem) {
                                const selectedIdx = this.value.findIndex(selected => selected.id === foundItem.id)
                                if(selectedIdx === -1) {
                                    this.selectedItems.push(foundItem)
                                }
                            }
                        })
                    }
                }
            }
            this.$emit('quick-search-click', item)
            if($event.target.parentNode.parentNode.previousSibling) {
                $event.target.parentNode.parentNode.previousSibling.focus()
                $event.target.parentNode.parentNode.style.display = 'none'
            }
            this.hide()
        },
        close() {
            this.searchText = ''
            this.hide()
        }
    },
    created() {
        if(typeof this.value === 'object' && Object.keys(this.value).length > 0) {
            this.$set(this, 'selectedItems', this.value.map(item => {
                return {
                    id: item.id,
                    name: item.name
                }
            }))
        }
    }
}
</script>
